import React      from 'react';
import classnames from 'classnames';
import { START }  from 'pu-data/QuoteSteps';

import GerberFile   from 'pu-react/components/GerberFile';
import InstantQuote from 'pu-react/components/InstantQuote';
import PartNumber   from 'pu-react/components/PartNumber';
import Revision     from 'pu-react/components/Revision';
import Quantities   from 'pu-react/components/Quantities';

// import NumberLayer           from 'pu-react/components/NumberLayer';
import BoardSize             from 'pu-react/components/BoardSize';
// import MaterialType          from 'pu-react/components/MaterialType';
import MaterialThicknessFlex from 'pu-react/components/MaterialThicknessFlex';
import FinishPlating         from 'pu-react/components/FinishPlating';
import CopperWeightOuters    from 'pu-react/components/CopperWeightOuters';
// import Soldermask            from 'pu-react/components/Soldermask';
import Silkscreen            from 'pu-react/components/Silkscreen';

import SupplierSelected   from 'pu-react/components/SupplierSelected';
import ProductQuoteNumber from 'pu-react/components/ProductQuoteNumber';
import RowSelected        from 'pu-react/components/RowSelected';
import ColumnSelected     from 'pu-react/components/ColumnSelected';

import SpecialInstruction  from 'pu-react/components/SpecialInstruction';
import RequiredInformation from 'pu-react/components/RequiredInformation';

import RigidFlexSelector from './form/RigidFlexSelector';
import MaterialThickness from './form/MaterialThickness';
import NumberLayer       from './form/NumberLayer';
import NumberLayerFlex   from './form/NumberLayerFlex';
import MaterialType      from './form/MaterialType';
import Soldermask        from './form/Soldermask';
import CustomQuote       from './form/CustomQuote';

import { finishPlatingFlex, silkscreenColor, copperOuter } from '../data/SelectOptions';

export default (props) => {
  const projectInfoClass = classnames('row', { 'd-none': props.quoteStep === START });
  const flexSelected = props.parameters.rigid_flex_selector === 'Flex';

  // conditional label components
  const materialThicknessFlexLabel = !flexSelected
    ? 'Flex<br class="d-none d-lg-block" /> Thickness'
    : 'Finish<br class="d-none d-lg-block" /> Thickness';

  return (
    <div className={classnames('pcb-form-section', { 'rigid-flex-form': !flexSelected })}>
      <div className="row">
        <div className="col-md-12">
          <RigidFlexSelector {...props} />
        </div>
        <div className="col-md-6">
          <GerberFile {...props} />
        </div>
        <div className="col-md-6 instant-quote-top">
          <InstantQuote {...props} />
        </div>
      </div>
      <div className={projectInfoClass}>
        <div className="col-md-6">
          <PartNumber {...props} />
        </div>
        <div className="col-md-6">
          <Revision data={{ 'data-rule-required': 'true' }} {...props} />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <Quantities {...props} />
        </div>

        <div className={classnames('col-6 col-lg-12 col-xl-6', { 'd-none': !flexSelected })}>
          <NumberLayer {...props} show={flexSelected === true} />
        </div>
        <div className="col-6 col-lg-12 col-xl-6">
          <BoardSize {...props} />
        </div>
        <div className={classnames('col-md-12', { 'd-none': !flexSelected })}>
          <div className="error_board_size" />
        </div>
        <div className="col-md-6">
          <MaterialType {...props} />
        </div>
        <div className={classnames('col-md-12', { 'd-none': flexSelected })}>
          <div className="error_board_size" />
        </div>
        <div className={classnames('col-md-6', { 'd-none': flexSelected })}>
          <NumberLayer
            {...props}
            show={flexSelected === false}
            label="Total # of layers" />
        </div>
        <div className={classnames('col-md-6', { 'd-none': flexSelected })}>
          <NumberLayerFlex
            {...props}
            show={flexSelected === false} />
        </div>
        <div className={classnames('col-md-6', { 'd-none': flexSelected })}>
          <MaterialThickness {...props} show={flexSelected === false} />
        </div>
        <div className="col-md-6">
          <MaterialThicknessFlex {...props} label={materialThicknessFlexLabel} />
        </div>
        <div className="col-md-6">
          <FinishPlating {...props} options={finishPlatingFlex} />
        </div>
        <div className="col-md-6">
          <CopperWeightOuters {...props} options={copperOuter} />
        </div>
        <div className="col-md-12">
          <Soldermask {...props} show={flexSelected === false} />
        </div>
        <div className="col-md-12">
          <Silkscreen {...props} colorOptions={silkscreenColor} />
        </div>

        <div className="col-md-12">
          <SpecialInstruction {...props} />
        </div>

        <div>
          <RowSelected {...props} />
          <ColumnSelected {...props} />
          <SupplierSelected {...props} />
          <ProductQuoteNumber {...props} />
          <input type="hidden" name="quantity" value="1" />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <RequiredInformation />
        </div>
        <div className="col-md-7">
          <InstantQuote {...props} />
        </div>
      </div>
      <CustomQuote {...props} />
    </div>
  );
};
